import { useQuery } from '@tanstack/react-query';
import { dashboardMainService } from 'v2/services/dashboardMain';

export const useListNewzz = (quantity?: number) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['dashboard', 'listNewzz', quantity],
    queryFn: () => dashboardMainService.listNewzz(quantity)
  });

  return { newzzList: data?.data ?? [], isLoading, error, refetch };
};
